/* Assets/fungi-wholesale.js */
document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('WholesaleContactForm');
  if (!form) return;

  // Progressive Enhancement: activar validación custom solo si JS está disponible
  form.setAttribute('novalidate', 'true');
  let formStarted = false;

  // 📊 TRACKING GA4 / DATALAYER CON FALLBACKS UNIFICADOS
  function trackGA4(eventName, params) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, params);
    } else if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: eventName }, params));
    }
  }

  function trackFormStart() {
    if (!formStarted) {
      formStarted = true;
      trackGA4('wholesale_form_start', {
        event_category: 'formulario_mayoristas',
        event_label: 'Inicio de interacción'
      });
    }
  }

  form.querySelectorAll('input, select, textarea').forEach(input => {
    input.addEventListener('focus', trackFormStart);
    input.addEventListener('input', trackFormStart);
  });

  // Validación matemática estricta para teléfonos
  function validarTelefonoJS(value) {
    const digitos = value.replace(/\D/g, '');
    return digitos.length >= 8 && digitos.length <= 15;
  }

  // Limpiar errores visuales y de accesibilidad ARIA al escribir
  form.querySelectorAll('input').forEach(input => {
    input.addEventListener('input', function() {
      if (this.classList.contains('has-error')) {
        let isFieldValid = this.checkValidity();
        if (this.type === 'tel' && this.value.trim() !== '') {
          isFieldValid = validarTelefonoJS(this.value);
        }

        if (isFieldValid) {
          this.classList.remove('has-error');
          this.setAttribute('aria-invalid', 'false');
          const errorSpan = this.closest('.fungi-form-group, fieldset')?.querySelector('.fungi-error-text');
          if (errorSpan) errorSpan.style.display = 'none';
        }
      }
    });
    
    if (input.type === 'radio') {
      input.addEventListener('change', function() {
        const fieldset = this.closest('fieldset');
        if (fieldset) {
          const errorSpan = fieldset.querySelector('.fungi-error-text');
          if (errorSpan) errorSpan.style.display = 'none';
        }
      });
    }
  });

  // 🔒 CONTROL DE ENVÍO Y VALIDACIÓN COMPLETA
  form.addEventListener('submit', function(e) {
    let hasErrors = false;
    const requiredFields = form.querySelectorAll('[required]');

    // 1. REVISIÓN DE INTEGRIDAD DE CAMPOS
    requiredFields.forEach(input => {
      const container = input.closest('.fungi-form-group, fieldset');
      const errorSpan = container ? container.querySelector('.fungi-error-text') : null;

      let isFieldValid = input.checkValidity();
      if (input.type === 'tel' && input.value.trim() !== '') {
        isFieldValid = validarTelefonoJS(input.value);
      }

      if (!isFieldValid) {
        hasErrors = true;
        if (input.type !== 'radio' && input.type !== 'checkbox') {
          input.classList.add('has-error');
          input.setAttribute('aria-invalid', 'true');
        }
        if (errorSpan) {
          if (input.type === 'tel' && input.value.trim() !== '') {
            errorSpan.textContent = 'Ingresa un teléfono válido de 8 a 15 números.';
          } else if (input.validity.valueMissing) {
            errorSpan.textContent = input.type === 'radio' ? 'Por favor selecciona una opción.' : 'Este campo es obligatorio.';
          } else if (input.validity.patternMismatch || input.validity.typeMismatch) {
            errorSpan.textContent = input.title || 'Formato inválido.';
          }
          errorSpan.style.display = 'block';
        }
      }
    });

    // 2. FILTRO DE SEGURIDAD HONEYPOT (Bots)
    const hpInput = document.getElementById('Wholesale-HP');
    if (hpInput && hpInput.value.trim() !== "") {
      e.preventDefault(); 
      e.stopImmediatePropagation();
      console.warn("🤖 Bot detectado (Honeypot). Envío bloqueado.");
      trackGA4('spam_attempt_blocked', { event_category: 'seguridad', method: 'honeypot' });
      return; 
    }

    // 🚨 3. MANEJO DE ENFOQUE SI EXISTEN ERRORES
    if (hasErrors) {
      e.preventDefault(); 
      e.stopImmediatePropagation();

      setTimeout(() => {
        let firstError = form.querySelector('.has-error');
        
        if (!firstError) {
          const radioGroup = form.querySelector('fieldset [name="contact[Tipo de Negocio]"]');
          const isSelected = form.querySelector('input[name="contact[Tipo de Negocio]"]:checked');
          if (radioGroup && !isSelected) {
            firstError = radioGroup;
          }
        }
        if (!firstError) {
          firstError = form.querySelector('[required]:invalid');
        }
        if (firstError) {
          firstError.focus();
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 50);
      return; 
    }

    // ✅ 4. CASO EXITOSO (Humano validado): Flujo natural sin preventDefault
    
    // Eliminación del name para evitar campos vacíos en la bandeja de entrada
    if (hpInput) hpInput.removeAttribute('name'); 

    // Disparar métricas de conversión
    const tipoNegocioEl = form.querySelector('input[name="contact[Tipo de Negocio]"]:checked');
    const tipoNegocioValue = tipoNegocioEl ? tipoNegocioEl.value : 'No especificado';
    trackGA4('wholesale_form_submit', {
      event_category: 'formulario_mayoristas',
      tipo_de_negocio: tipoNegocioValue
    });

    // Deshabilitar botón con mini-delay para no interrumpir los scripts nativos de Shopify
    const btn = document.getElementById('WholesaleSubmitBtn');
    if (btn) {
      setTimeout(() => {
        btn.disabled = true;
        btn.textContent = 'Enviando solicitud...';
      }, 10);
      
      // Fallback de red: restaurar botón a los 30 segundos si hay timeout de servidor
      setTimeout(() => {
        if (btn.disabled && !form.classList.contains('submitted')) {
          btn.disabled = false;
          btn.textContent = 'Solicitar Catálogo Mayorista';
          console.warn('⚠️ Timeout del servidor: botón re-habilitado');
        }
      }, 30000);
    }
  });

  // Gestión de accesibilidad y foco post-envío exitoso
  const successMessage = document.getElementById('FungiSuccessMessage');
  if (successMessage) {
    setTimeout(() => {
      form.classList.add('submitted');
      successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      successMessage.focus(); 
    }, 100);
  }
});